var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"panel-section"},[(_vm.title)?_c('h5',{staticClass:"panel-section__title"},[_vm._v(_vm._s(_vm.title)),(_vm.help)?_c('metric-info-tooltip',{attrs:{"content":_vm.help}}):_vm._e()],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }